module.exports = __webpack_public_path__ + "img/HindSight.d4fa077e.png";